import {Component, OnInit} from '@angular/core';
import {MetaService} from '../../../services/meta/meta.service';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {ActivatedRoute, Router} from '@angular/router';
import {LangSrcService} from '../../../services/lang-src/lang-src.service';
import {EvaluationService} from '../../../services/evaluation/evaluation.service';
import {AudioService} from '../../../services/audio/audio.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {EvaluationSkipTestComponent} from '../evaluation-skip-test/evaluation-skip-test.component';
import {EvaluationResultComponent} from '../evaluation-result/evaluation-result.component';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'app-evaluation-questions',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule
  ],
  templateUrl: './evaluation-questions.component.html',
  styleUrls: ['./evaluation-questions.component.scss']
})
export class EvaluationQuestionsComponent implements OnInit {

  loading = true;
  item: any;
  selectedAnswer: any;
  gapParts: string[] = [];

  constructor(
    private metaSrv: MetaService,
    private translate: TranslateService,
    private langSrcSrv: LangSrcService,
    private router: Router,
    private route: ActivatedRoute,
    private evaluationSrv: EvaluationService,
    public audioSrv: AudioService,
    private modal: NgbModal
  ) {
  }

  trackByIndex(index: number) { return index; }

  async ngOnInit() {
    this.translate.get(`Test d'évaluation`).subscribe((value: string) => {
      this.metaSrv.setMetas({title: value});
    });
    await this.getQuestion();
  }

  async close() {
    this.modal.open(EvaluationSkipTestComponent, { centered: true });
  }

  async getQuestion(uniqid?: string) {
    this.item = await this.evaluationSrv.getQuestion(this.route.snapshot.params.langTgt, uniqid);
    // Texte à trou : pas de type dédié dans le payload, on détecte le marqueur [?]
    this.gapParts = (this.item.question.title && this.item.question.title.includes('[?]'))
      ? this.item.question.title.split('[?]')
      : [];
    this.selectedAnswer = null;
    this.loading = false;
  }

  async selectAnswer(answer: any) {
    this.selectedAnswer = answer;
    if (answer.audio) {
      await this.audioSrv.play(answer.audio, false, this.route.snapshot.params.langTgt);
    }
  }

  async next() {
    const answer = (this.selectedAnswer.uniqid) ? this.selectedAnswer.uniqid : null;
    const response: any = await this.evaluationSrv.answer(this.route.snapshot.params.langTgt, {
      question: this.item.question.uniqid,
      answer
    });
    if (response.redirectTo === 'question') {
      await this.getQuestion(response.uniqid);
      return;
    }
    await this.displayResult(response);
  }

  async displayResult(response: any) {
    const modal = this.modal.open(EvaluationResultComponent, { centered: true, backdrop: 'static' });
    modal.componentInstance.codeLang = this.route.snapshot.params.langTgt;
    modal.componentInstance.response = response;
  }

}
